import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import remarkBreaks from "remark-breaks"

interface MarkdownPreviewProps {
  value: string
  css: string
}

export function MarkdownPreview({ value, css }: MarkdownPreviewProps) {
  // Escape angle brackets in link text so rehype-raw doesn't parse them as HTML tags.
  // [<Open Whisper Memos>](url) -> [&lt;Open Whisper Memos&gt;](url)
  const processedValue = (value || "*No content to preview*").replace(
    /\[<([^>\]]+)>\]\(/g,
    "[&lt;$1&gt;](",
  )

  return (
    <div className="markdown-preview h-full rounded border border-gray-300 bg-white p-3">
      <style>{css}</style>
      <div className="email-content">
        <ReactMarkdown
          remarkPlugins={[remarkBreaks]}
          rehypePlugins={[rehypeRaw]}
          components={{
            a: ({ href, children, ...props }) => {
              const childText = children?.toString() || ""
              const isButtonLink = childText.match(/^<.*>$/)

              if (isButtonLink) {
                const cleanText = childText.replace(/^<|>$/g, "")
                return (
                  <a href={href} className="button" target="_blank" rel="noopener" {...props}>
                    {cleanText}
                  </a>
                )
              }

              return (
                <a href={href} target="_blank" rel="noopener" {...props}>
                  {children}
                </a>
              )
            },
          }}
        >
          {processedValue}
        </ReactMarkdown>
      </div>
    </div>
  )
}
